<div class="modal-container">
    <div hsg-modal-header *ngIf="data.title">
        <h3>
            {{ data.title }}
            <a class="modal-close-icon cancel" (click)="close()" hsgModalClose>
                <span class="icon-cross"></span>
            </a>
        </h3>
    </div>
    <div hsg-modal-body class="modal-guts">
        <div *ngIf="[data.isVariable]">
            <table *ngIf="data.jobTitles.length > 0" [class.title1]="data.jobTitles.length === 1"
                id="variableStaffingList" class="condensed form-group variable">
                <thead class="fixed-header">
                    <tr class="shift-block-head">
                        <ng-container *ngFor="let shiftBlock of data.selectedShiftBlocks">
                            <th class="census"></th>
                            <th [colSpan]="data.jobTitles.length">{{ shiftBlock.description }}</th>
                        </ng-container>
                    </tr>
                    <tr>
                        <ng-container *ngFor="let shiftBlock of data.selectedShiftBlocks">
                            <th class="census"></th>
                            <th *ngFor="let variableJobTitle of data.jobTitles; let i = index">
                                {{ variableJobTitle.abbreviation }}
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody class="scrolling-body">
                    <tr *ngFor="let variableCensusRow of data.selectedCensusTable; let i=index;">                        
                        <ng-container *ngFor="let variableCensusCell of variableCensusRow; let cellIndex=index;">
                            <td class="census" *ngIf="cellIndex%data.jobTitles.length === 0">
                                {{ data.selectedMaxCensus - i }}
                            </td>
                            <td>
                                <input #variableCell disabled type="number" [value]="variableCensusCell.value">
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="!data.isVariable">
            <table *ngIf="data.jobTitles.length > 0" [class.title1]="data.jobTitles.length === 1" id="fixedStaffingList"
                class="condensed form-group fixed">
                <thead class="fixed-header">
                    <tr class="shift-block-head">
                        <ng-container *ngFor="let shiftBlock of data.selectedShiftBlocks">
                            <th class="census"></th>
                            <th [colSpan]="data.jobTitles.length">{{ shiftBlock.description }}</th>
                        </ng-container>
                    </tr>
                    <tr>
                        <ng-container *ngFor="let shiftBlock of data.selectedShiftBlocks">
                            <th class="census"></th>
                            <th *ngFor="let fixedJobTitle of data.jobTitles; let i = index">
                                {{ fixedJobTitle.abbreviation }}
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody class="scrolling-body">
                    <tr *ngFor="let fixedCensusRow of data.selectedCensusTable; let i=index;">
                        <ng-container *ngFor="let fixedCensusCell of fixedCensusRow; let cellIndex=index;">
                            <td class="census" *ngIf="cellIndex%data.jobTitles.length === 0"></td>
                            <td>
                                <input #fixedCell disabled type="number" [value]="fixedCensusCell.value">
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>